var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditorLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#8688A5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76954 17.2306C5.86502 16.3261 5.82927 14.8973 6.68963 14.037L9.7487 10.9779L8.55703 9.78623L5.49796 12.8453C4.0094 14.3339 4.07108 16.7991 5.63604 18.3641C7.20101 19.929 9.66625 19.9907 11.1548 18.5022L14.2139 15.4431L13.0222 14.2514L9.96314 17.3105C9.10278 18.1708 7.67406 18.1351 6.76954 17.2306ZM9.78612 8.55714L10.9778 9.74881L14.0369 6.68974C14.8972 5.82938 16.3259 5.86512 17.2305 6.76965C18.135 7.67417 18.1707 9.10289 17.3104 9.96325L14.2513 13.0223L15.443 14.214L18.502 11.1549C19.9906 9.66636 19.9289 7.20112 18.364 5.63615C16.799 4.07118 14.3338 4.0095 12.8452 5.49807L9.78612 8.55714ZM8.7634 15.2367C9.09362 15.5669 9.62589 15.5803 9.93999 15.2662L15.2797 9.92644C15.5938 9.61234 15.5805 9.08007 15.2503 8.74985C14.92 8.41962 14.3878 8.40631 14.0737 8.72041L8.73396 14.0601C8.41986 14.3742 8.43318 14.9065 8.7634 15.2367Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorLink);
export default __webpack_public_path__ + "static/media/editor-link.e309f2c4.svg";
export { ForwardRef as ReactComponent };